import React from 'react'
import { Link } from 'react-router-dom';
import "./unsubscribestyle.css"
const UnsubscribePage = () => {
    return (
        <>
            <div className="container">
                <div className="card my-3" style={{textAlign:"center"}}>
                    {/* <div className="card-header">
                        Featured
                    </div> */}
                    <div className="card-body">
                        <img src="./assets/img/unsubscribe_jpg.jpg" alt="unsubscribe" className="vert-move" style={{height:'200px',width:"200px"}}/>
                        <h5 className="card-title">You will be missed.</h5>
                        <p className="card-text text-center">You are now unsubscribed from Alobha Technologies.</p>
                        {/* <Link to="/" className="btn btn-primary"></Link> */}
                        <Link to='/'><button className="btn btn-sm btn-success">Go to Home Page &#8594;</button></Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UnsubscribePage